const fields = [
  {
    key: 'suffix',
    type: 'input',
    templateOptions: {
      classes: {
        'suffix-input': true
      },
      label: 'suffix'
    }
  },
  {
    key: 'out_of_competition',
    type: 'boolean',
    templateOptions: {
      label: 'out_of_competition'
    }
  }
]

export default fields
